import React, {
    useRef,
    forwardRef,
    useImperativeHandle,
    useEffect,
} from 'react';

import './Minimap.scss';

import { trackEvent } from '../../lib/analytics';

export const Minimap = forwardRef(({ isOpen = false }, ref) => {
    const staticCanvasRef = useRef(null);
    const dynamicCanvasRef = useRef(null);

    // Використовуємо useImperativeHandle для надання доступу до обох канвасів
    useImperativeHandle(ref, () => ({
        staticCanvas: staticCanvasRef.current,
        dynamicCanvas: dynamicCanvasRef.current,
    }));

    useEffect(() => {
        // Можна ініціалізувати канваси або налаштувати їх
        const staticCanvas = staticCanvasRef.current;
        const dynamicCanvas = dynamicCanvasRef.current;

        const staticCtx = staticCanvas.getContext('2d');
        const dynamicCtx = dynamicCanvas.getContext('2d');

        // Ініціалізація канвасів
        staticCtx.clearRect(0, 0, staticCanvas.width, staticCanvas.height);
        dynamicCtx.clearRect(0, 0, dynamicCanvas.width, dynamicCanvas.height);
    }, []);

    return (
        <div
            className="minimap"
            style={{ display: `${isOpen ? 'flex' : 'none'}` }}
        >
            <div className="minimap-inner" onClick={() => {
            }}>
                {/* <canvas ref={staticCanvasRef} width="200" height="200" style={{ position: 'absolute', top: 0, left: 0 }} />
				<canvas ref={dynamicCanvasRef} width="200" height="200" style={{ position: 'absolute', top: 0, left: 0 }} /> */}
                <canvas
                    ref={staticCanvasRef}
                    width="263.83"
                    height="152"
                    className="minimap-canvas-static"
                />
                <canvas
                    ref={dynamicCanvasRef}
                    width="263"
                    height="152"
                    className="minimap-canvas-dynamic"
                />
            </div>
        </div>
    );
});

export default Minimap;
